import { render, staticRenderFns } from "./TotalCostSpanWidget.vue?vue&type=template&id=70457669&"
import script from "./TotalCostSpanWidget.vue?vue&type=script&lang=js&"
export * from "./TotalCostSpanWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports